import * as React from 'react';

import moment from 'moment';
import 'moment-timezone';
import TimePicker from 'components/time_picker';
import DatePicker from 'components/date_picker';
import { DateTimePicker as AtlaskitDateTimePicker } from '@atlaskit/datetime-picker';

interface DateTimePickerState {
  date: moment.Moment;
}

interface DateTimePickerProps {
  timezone: string;
  timezoneDisplay: string;
  use_adg3_manage_style?: boolean;
}

export default class DateTimePicker extends React.PureComponent<
  DateTimePickerProps,
  DateTimePickerState
> {
  static defaultProps = {
    timezone: 'UTC',
    timezoneDisplay: 'UTC',
  };

  constructor(props: DateTimePickerProps) {
    super(props);
    const now = moment().tz(props.timezone);
    this.state = { date: now };
  }

  updateDate = (date: moment.Moment) => {
    const momentDate = moment.tz(
      moment(date).format('YYYY-MM-DDTHH:mm:ss'),
      this.props.timezone,
    );
    this.setState({ date: momentDate });
  };

  render() {
    const times = [
      '00:00',
      '00:30',
      '01:00',
      '01:30',
      '02:00',
      '02:30',
      '03:00',
      '03:30',
      '04:00',
      '04:30',
      '05:00',
      '05:30',
      '06:00',
      '06:30',
      '07:00',
      '07:30',
      '08:00',
      '08:30',
      '09:00',
      '09:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00',
      '15:30',
      '16:00',
      '16:30',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
      '21:30',
      '22:00',
      '22:30',
      '23:00',
      '23:30',
    ];
    return (
      <div className="date-time-picker-wrapper">
        {this.props.use_adg3_manage_style ? (
          <AtlaskitDateTimePicker
            onChange={this.updateDate}
            value={moment(this.state.date).format('YYYY-MM-DDTHH:mm:ss')}
            timeIsEditable // allows values not specified in times
            disabled={false}
            times={times}
            style={{
              width: '100%',
            }}
          />
        ) : (
          <div className="date-time-picker row">
            <div className="backfill-date-picker span6">
              <DatePicker
                onChange={this.updateDate}
                selectedDate={this.state.date}
                disabled={false}
              />
            </div>
            <div className="backfill-time-picker span6">
              <TimePicker
                onChange={this.updateDate}
                selectedDate={this.state.date}
                disabled={false}
              />
            </div>
          </div>
        )}
        <input
          type="hidden"
          name="incident[backfill_date]"
          value={this.state.date.toISOString()}
        />
      </div>
    );
  }
}
